import { MessageSquare } from "lucide-react";
import PopupState, { bindHover, bindPopover } from "material-ui-popup-state";
import HoverPopover from "material-ui-popup-state/HoverPopover";
import React from "react";
import {
  convertTimestampToReadableDate2,
  convertTimestampToReadableDate2year,
  reverseAndSortByDate,
} from "../../../utils/utils";

const Logs = ({ data }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorPosition, setAnchorPosition] = React.useState({
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center",
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center",
      },
    });
  const dataReversed = reverseAndSortByDate(data);
  const handleMouseOver = (event) => {
    event.stopPropagation();
    // console.log("event");
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleMouseOut = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const handleMouseEnter = (event, popupState) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    if (spaceBelow < 200 && spaceAbove > 200) {
      // Show above
      setAnchorPosition({
        anchorOrigin: { vertical: "top", horizontal: "center" },
        transformOrigin: { vertical: "bottom", horizontal: "center" },
      });
    } else {
      // Show below (default)
      setAnchorPosition({
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        transformOrigin: { vertical: "top", horizontal: "center" },
      });
    }

    popupState.open(event);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <PopupState variant="popover" popupId="comment-popover">
        {(popupState) => (
          <div>
            <div 
            {...bindHover(popupState)} 
            className="px-1" 
            onMouseEnter={(e) => handleMouseEnter(e, popupState)}
            >
              {dataReversed[0].user_name}
            </div>
            <HoverPopover
              {...bindPopover(popupState)}
              anchorOrigin={anchorPosition.anchorOrigin}
              transformOrigin={anchorPosition.transformOrigin}
            >
              <div className="bg-transparent  border border-[#cbcbcb]">
                <div className="text-[0.685rem] flex justify-evenly mt-1">
                  <div className="p-1 rounded-lg bg-white ">
                    <div className="h-full bg-[#F3F3F3] rounded-lg min-w-[180px] min-h-[200px] max-h-[250px] overflow-y-auto">
                      {dataReversed ? (
                        <div className="max-h-[350px] overflow-y-auto px-2 py-1">
                          {dataReversed.map((item) => {
                            if (item.is_repricing_comment) {
                              return (
                                <>
                                  <div className="text-[0.55rem] font-base my-1 text-[#9A9A9A] italic">
                                    @{item.user_name} {" : "}
                                    {convertTimestampToReadableDate2year(item.date)}
                                  </div>

                                  <div className="text-[0.66rem] font-base my-1 mb-2 text-[#5A5A5A] italic">
                                    {item.comment}
                                  </div>
                                </>
                              );
                            }
                          })}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </HoverPopover>
          </div>
        )}
      </PopupState>
    </>
  );
};

export default Logs;
